import { ITEM_TYPES } from '@wix/advanced-seo-utils';
import _ from 'lodash';
import { useCallback } from 'react';
import { useAltTextScreenContext } from '../drill-in/alt-text-screen/alt-text-screen-wrapper';
const UNSUPPORTED_EXTENSION = '_UNSUPPORTED';
export const useEntityGroups = () => {
  const {
    actions: {
      altHandlers,
      staticAltHandlers
    },
    state: {
      isSortedByUnsupported,
      itemType,
      pageId
    }
  } = useAltTextScreenContext();
  const getEntityName = altHandlers == null ? void 0 : altHandlers.getEntityName;
  const getEntityPriority = altHandlers == null ? void 0 : altHandlers.getEntityPriority;
  const sortUnsupportedFirst = useCallback(groups => {
    const entries = Object.entries(groups);
    entries.sort((_ref, _ref2) => {
      let [groupA] = _ref;
      let [groupB] = _ref2;
      const aHasPriority = groupA.endsWith(UNSUPPORTED_EXTENSION);
      const bHasPriority = groupB.endsWith(UNSUPPORTED_EXTENSION);
      return Number(bHasPriority) - Number(aHasPriority);
    });
    return Object.fromEntries(entries);
  }, []);
  const getGroupPriority = useCallback(group => {
    // cross-page images should be sorted to the top
    if (group.id === pageId) {
      return Number.MAX_SAFE_INTEGER;
    }
    return group.elements.reduce((max, element) => {
      const priorityB = (getEntityPriority == null ? void 0 : getEntityPriority(element.id)) ?? 0;
      return Math.max(max, priorityB);
    }, -Infinity);
  }, [getEntityPriority, pageId]);
  const sortByPriority = useCallback(groups => {
    const entries = Object.entries(groups);
    entries.sort((_ref3, _ref4) => {
      let [_groupAName, groupA] = _ref3;
      let [_groupBName, groupB] = _ref4;
      const groupAMaxPriority = getGroupPriority(groupA);
      const groupBMaxPriority = getGroupPriority(groupB);
      return Number(groupBMaxPriority) - Number(groupAMaxPriority);
    });
    return Object.fromEntries(entries);
  }, [getGroupPriority]);
  const getGroups = useCallback(imageElements => {
    const elementsByEntityId = _.groupBy(imageElements, element => {
      return element.entityId ?? '';
    });
    const groups = Object.entries(elementsByEntityId).reduce((acc, _ref5) => {
      let [groupId, images] = _ref5;
      if (!images || images.length === 0) {
        return acc;
      }
      const elementId = images[0].id;
      const entityId = images[0].entityId;
      const groupName = itemType && itemType !== ITEM_TYPES.STATIC_PAGE_V2 ? (getEntityName == null ? void 0 : getEntityName(entityId ?? '')) || (staticAltHandlers == null || staticAltHandlers.getEntityName == null ? void 0 : staticAltHandlers.getEntityName(elementId)) || '' : '';
      if (isSortedByUnsupported) {
        const unsupportedGroup = images.filter(image => !image.isAiSupported);
        const supportedGroup = images.filter(image => image.isAiSupported);
        const unsupportedGroupId = `${groupId}${UNSUPPORTED_EXTENSION}`;
        if (unsupportedGroup.length > 0) {
          acc[unsupportedGroupId] = {
            elements: unsupportedGroup,
            id: unsupportedGroupId,
            name: groupName
          };
        }
        if (supportedGroup.length > 0) {
          acc[groupId] = {
            elements: supportedGroup,
            id: groupId,
            name: groupName
          };
        }
      } else {
        acc[groupId] = {
          elements: images ?? [],
          id: groupId,
          name: groupName
        };
      }
      return acc;
    }, {});
    const groupsArray = isSortedByUnsupported ? Object.values(sortUnsupportedFirst(groups)) : Object.values(sortByPriority(groups));
    return groupsArray;
  }, [getEntityName, isSortedByUnsupported, itemType, sortByPriority, sortUnsupportedFirst, staticAltHandlers]);
  return getGroups;
};
//# sourceMappingURL=use-entity-groups.js.map